import { useEffect, useState } from 'react'
import Lottie from 'lottie-react'
import { Container } from 'react-bootstrap'
import { useParams } from 'react-router-dom'

import Heading from '@/components/ui/Heading'
import { BrokerRibbon } from '@/components/ui/MotorTrade/BrokerRibbon'
import { getReferral } from '@/api/referral'
import animationData from '@/assets/images/cg_loading.json'
import CG_Logo from '@/assets/images/cg_logo.png'

const brokerBaseURL = import.meta.env.VITE_COVERX_BROKER_DASH
const brokerDashboardURL = brokerBaseURL + '/broker/dashboard'
const returnDashboard = () => {
  sessionStorage.clear()
}
const MTBrokerBuyReferral = ({ isAlternate }: { isAlternate?: boolean }) => {
  const { guid } = useParams()
  const [referralDetails, setReferralDetails] = useState<{
    quoteRef: string
  }>()

  useEffect(() => {
    if (guid) getReferral(guid).then((res) => setReferralDetails(res.data))
  }, [])

  return (
    <>
      <Container bsPrefix="container-fluid">
        <div className="d-flex align-items-center mt-3 p-3">
          <div className="logo">
            <img src={CG_Logo} alt="CG logo" />
          </div>
        </div>
      </Container>
      <div className="mt-3">
        <BrokerRibbon />
      </div>
      <div
        className="container container-body-md mt-4 bg-light rounded-3 p-3"
        style={{
          padding: '16px 16px',
          marginTop: '16px',
          marginBottom: '16px',
        }}
      >
        <div className="text-center">
          <div
            className="fw-bold"
            style={{ color: '#FC2766', marginBottom: 0 }}
          >
            <Heading title="Thank You for Your Recent Submission" />
          </div>
          <div
            className="border-top border-danger border-dashed mb-16"
            style={{ color: '#FC2766' }}
          ></div>
        </div>
        {!referralDetails && (
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(255, 255, 255, 0.6)',
              zIndex: 9999,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Lottie
              animationData={animationData}
              loop
              autoplay
              style={{ height: 150, width: 150 }}
            />
          </div>
        )}
        {referralDetails && (
          <>
            <p>
              The risk is now with our team for final review and completion of
              relevant underwriting checks.
            </p>
            <p>
              If you should require an immediate response, please call the team
              on <br />
              <strong>{isAlternate ? '0203 9464 210' : '0333 313 3030'}</strong>
            </p>
            <p>
              Or alternatively email <br />
              <a
                href={
                  isAlternate
                    ? 'mailto:londonmarket@cginsurance.com'
                    : 'mailto:sales@cginsurance.com'
                }
                className="text-primary"
              >
                {isAlternate
                  ? 'londonmarket@cginsurance.com'
                  : 'sales@cginsurance.com'}
              </a>
            </p>
            <div
              className="border-top border-danger border-dashed my-3"
              style={{ color: '#FC2766' }}
            ></div>
            <p className="mb-0">
              <strong>Reference: {referralDetails.quoteRef}</strong>
            </p>
          </>
        )}
      </div>
      <div className="text-center mt-4">
        <a
          className="btn btn-primary"
          href={brokerDashboardURL}
          onClick={returnDashboard}
        >
          Return to Broker Dashboard
        </a>
      </div>
    </>
  )
}

export default MTBrokerBuyReferral
